module.exports = __webpack_public_path__ + "media/images/ecalls/guaranteed_badge_pt-dcff436a78f6e3c6f3ae380eea6c341d.png";